// TODO: Cleanup
import $axios from '@/axios-instance.js'

export const invoiceService = {
  getListData,
  getInvoiceableProjects,
  createPreviewFromProjectId,
  createPreviewPdfFromProjectId,
  createCreditInvoicePreview,
  createFromProjectId,
  createCreditInvoice,
  // createPreviewHtmlFromProjectId,
  // getAll,
  getById,
  // create,
  // update,
  // delete: _delete
  downloadInvoicePdf,
  recreateInvoicePdf
}

function getListData (filter, page) {
  return $axios.get(`${process.env.ROOT_API}/invoices`, { params: Object.assign({ currentPage: page }, filter) }).then(response => {
    return response.data
  })
}

function getInvoiceableProjects (filter, page) {
  return $axios.get(`${process.env.ROOT_API}/invoices/get-invoiceable-projects`, { params: Object.assign({ currentPage: page }, filter) }).then(response => {
    return response.data
  })
}

function createPreviewFromProjectId (projectId) {
  return $axios.get(`${process.env.ROOT_API}/invoices/create-preview-from-project/${projectId}`).then(response => {
    return response.data
  })
}

function createPreviewPdfFromProjectId (projectId) {
  return $axios.get(`${process.env.ROOT_API}/invoices/create-preview-pdf-from-project/${projectId}`).then(response => {
    return response.data
  })
}

function createFromProjectId (projectId) {
  return $axios.get(`${process.env.ROOT_API}/invoices/create-from-project/${projectId}`).then(response => {
    return response.data
  })
}

function createCreditInvoicePreview (invoiceId) {
  return $axios.get(`${process.env.ROOT_API}/invoices/create-credit-invoice-preview/${invoiceId}`).then(response => {
    return response.data
  })
}

function createCreditInvoice (invoiceId) {
  return $axios.get(`${process.env.ROOT_API}/invoices/create-credit-invoice/${invoiceId}`).then(response => {
    return response.data
  })
}

function recreateInvoicePdf (invoiceId) {
  return $axios.get(`${process.env.ROOT_API}/invoices/recreate-invoice-pdf/${invoiceId}`).then(response => {
    return response.data
  })
}

function downloadInvoicePdf (invoiceId) {
  var config = {
    headers: { 'Content-Type': 'application/pdf', 'Accept': 'application/pdf' },
    responseType: 'blob'
  }
  return $axios.post(`${process.env.ROOT_API}/invoices/download/${invoiceId}`, {id: invoiceId}, config
  ).then(response => {
    return response
  }).catch(error => {
    console.error(error.response)
  })
}

/*
function createPreviewHtmlFromProjectId (projectId) {
  return $axios.get(`${process.env.ROOT_API}/invoices/create-preview-html-from-project/${projectId}`).then(response => {
    return response.data
  })
}

function getAll () {
  return $axios.get(`${process.env.ROOT_API}/invoices/get-all`).then(response => {
    return response.data
  })
}
*/
function getById (id) {
  return $axios.get(`${process.env.ROOT_API}/invoices/${id}`).then(response => {
    return response.data
  })
}
/*
function create (invoice) {
  return $axios.post(`${process.env.ROOT_API}/invoices`, invoice).then(response => {
    return response.data
  })
}

function update (invoice) {
  return $axios.put(`${process.env.ROOT_API}/invoices/${invoice.invoiceId}`, invoice).then(response => {
    return response.data
  })
}

function _delete (id) {
  return $axios.delete(`${process.env.ROOT_API}/invoices/${id}`).then(response => {
    return response.data
  })
}
*/



// WEBPACK FOOTER //
// ./src/services/invoice.service.js